export default "__VITE_ASSET__Cpbl9XRu__"